if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"webform_ui","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 869 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}